'use strict';

require('./RoomService');
require('./CallsService');
var CallFieldsExtension = require('./CallFieldsExtension');
var TooltipExtension = require('./TooltipExtension').default;
var log = require('../../log/Log').channel('DirectoryController');
var defaults = require('../../defaults/Defaults');
var moment = require('moment');
var momentDurationFormatSetup = require('moment-duration-format');
var objectToArray = require('./ObjectToArray');
var sutl = require('../../sutl/Sutl');

momentDurationFormatSetup(moment);

angular.module('inara').controller('DirectoryController', DirectoryController);

DirectoryController.$inject = [
    '$rootScope',
    '$scope',
    '$ionicScrollDelegate',
    '$ionicPopover',
    'ionicMaterialInk',
    'KayleeService',
    'RoomService',
    'CallsService',
    '$ionicViewSwitcher',
    '$timeout',
    '$filter',
    '$window',
    '$document',
    'ContactUtilityService',
    '$state',
    '$q',
    'gettextCatalog',
    'SelectMenuPositionService',
    'IosTouchEventService',
];

function DirectoryController(
    $rootScope,
    $scope,
    $ionicScrollDelegate,
    $ionicPopover,
    ionicMaterialInk,
    KayleeService,
    RoomService,
    CallsService,
    $ionicViewSwitcher,
    $timeout,
    $filter,
    $window,
    $document,
    ContactUtilityService,
    $state,
    $q,
    gettextCatalog,
    SelectMenuPositionService,
    IosTouchEventService
) {
    var vm = this;
    var room = null;
    var lastScrollTop = 0;
    var maintainSearchFocus = false;
    var hasKeyboard =
        angular.isDefined($window.cordova) &&
        angular.isDefined($window.cordova.plugins) &&
        angular.isDefined($window.cordova.plugins.Keyboard);
    var clearDirectoryUiState = false;
    var durationControls = null;
    var dialingControls = null;
    var directoryItemWidth = '';
    var defaultBaseFontSizePx = 16;
    var entryItemHeightPx = 112;
    var dividerItemHeightPx = 26;
    var previousDirectoryBeforeModifiedTimestamp = null;
    var previousDirectoryModifiedTimestamp = null;
    var alreadyCheckedEntry = null;
    var roomServiceOnlineRegistered = false;
    var directoryEntryHandlersRegistered = false;
    var ignoreEntryAdded = false;
    var meetNowPressedCaption = null;
    var selectedDirectoryTab = null;
    var processingSearchResults = false;
    var entryOrderByMethods = [isNotRoom, getRoomNameOrLastName, getFirstNameOrLastName];
    var searchResultProcessSize = 10;
    var searchResultTimeout = null;
    var searchRegex = null;
    var directoryCanDial = false;
    var directoryCanInvite = false;
    var directoryEntryDividers = {};
    var previousKayleeConnected = KayleeService.isConnected();
    var updateSearchResultsTimeout = null;
    var viewActive = false;
    var wrappedIncrementDurationHandlers = IosTouchEventService.wrapHandlers(
        onIncrementDurationTouch
    );

    // Getter/setters for checked state of directory entries
    var entryChecked = {};

    // Cache of background/foreground color styles for directory entries
    // without avatar pictures
    var entryStyleCache = {};

    var zoomContactFilter = {
        type: 'zoom',
    };

    var otherContactFilter = {
        type: '!zoom',
    };

    log.info('initializing');

    angular.extend(vm, new CallFieldsExtension());
    angular.extend(vm, new TooltipExtension($scope, $ionicPopover));

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    if (hasKeyboard) {
        $window.addEventListener('native.keyboardhide', keyboardHideHandler);
    }

    KayleeService.onConnectionStateChanged(onKayleeConnectionStateChanged);

    vm.directoryTabs = [
        {
            name: 'zoom',
            /// Label for directory tab containing Zoom contacts
            getTitle: function () {
                return gettextCatalog.getString('Zoom');
            },
        },
        {
            name: 'phone',
            /// Label for directory tab containing phone contacts
            getTitle: function () {
                return gettextCatalog.getString('Phone');
            },
        },
    ];
    vm.getContactFilter = getContactFilter;
    vm.directory = null;
    vm.selectedEntry = null;
    vm.invitees = [];
    vm.durationInMinutes = 30;
    vm.minDuration = 5; // minutes
    vm.maxDuration = 240; // minutes
    vm.durationStep = 5; // minutes
    vm.onIncrementDurationRelease = wrappedIncrementDurationHandlers.onRelease;
    vm.onIncrementDurationTouch = wrappedIncrementDurationHandlers.onTouch;
    vm.onClearSearch = onClearSearch;
    vm.onChangeSearch = onChangeSearch;
    vm.onKeydownSearch = onKeydownSearch;
    vm.keepSearchFocused = keepSearchFocused;
    vm.onClickDirectoryTab = onClickDirectoryTab;
    vm.onClickSearch = onClickSearch;
    vm.onClickEntry = onClickEntry;
    vm.onCheckEntry = onCheckEntry;
    vm.onClickInvitee = onClickInvitee;
    vm.onUpdateInvitees = onUpdateInvitees;
    vm.onRemoveInvitee = onRemoveInvitee;
    vm.onShowDurationControls = onShowDurationControls;
    vm.formatDuration = formatDuration;
    vm.onResetSelections = onResetSelections;
    vm.showDirectoryTabs = showDirectoryTabs;
    vm.supportsInvitation = supportsInvitation;
    vm.isTabSelected = isTabSelected;
    vm.selectedTabSupportsInvitation = selectedTabSupportsInvitation;
    vm.supportsPresence = supportsPresence;
    vm.getPresenceMessage = getPresenceMessage;
    vm.onDialContact = onDialContact;
    vm.onMeetNow = onMeetNow;
    vm.getMeetNowButtonCaption = function () {
        if (meetNowPressedCaption !== null) return meetNowPressedCaption;
        return getMeetNowButtonCaption();
    };
    /// Placeholder for directory entry search field
    vm.getSearchPlaceholder = function () {
        return gettextCatalog.getString('Search');
    };
    vm.getMeetNowButtonClass = getMeetNowButtonClass;
    vm.getContactPictureStyle = getContactPictureStyle;
    vm.getContactInitials = ContactUtilityService.getContactInitials;
    vm.isEntryChecked = isEntryChecked;
    vm.canCallClass = canCallClass;
    vm.canCallType = canCallType;
    vm.getCallClass = getCallClass;
    vm.getCallMethodFromContact = getCallMethodFromContact;
    vm.getMeetingCodesLabel = getMeetingCodesLabel;
    vm.onScroll = onScroll;
    vm.search = '';
    vm.isKeyboardOpen = function () {
        return hasKeyboard && cordova.plugins.Keyboard.isVisible;
    };
    vm.getDirectoryItemWidth = function () {
        return directoryItemWidth;
    };
    vm.getDirectoryItemHeight = function (item) {
        if (!item) return '';

        if (item.isDivider) {
            return (dividerItemHeightPx * getBaseFontSize()) / defaultBaseFontSizePx + 'px';
        }
        return (entryItemHeightPx * getBaseFontSize()) / defaultBaseFontSizePx + 'px';
    };
    vm.getDirectoryLength = function () {
        return vm.directory && vm.directory.entries ? Object.keys(vm.directory.entries).length : 0;
    };
    vm.getEntryAffiliation = function (entry) {
        var affiliation = null;
        if (entry.hasOwnProperty('department') && entry.department.length > 0) {
            affiliation = entry.department;
        } else if (entry.hasOwnProperty('organization') && entry.organization.length > 0) {
            affiliation = entry.organization;
        }
        return affiliation;
    };
    vm.getEntryClasses = function (entry) {
        if (!angular.isDefined(entry)) return '';

        var classes = '';
        if (vm.selectedEntry === entry) {
            classes += ' selected';
        }
        if (entry.isDivider) {
            classes += ' divider';
        }
        return classes;
    };
    vm.processingSearchResults = function () {
        return processingSearchResults;
    };
    vm.showInvite = function () {
        return getCallForInvitation() !== null;
    };

    $scope.$on('$stateChangeSuccess', onStateChange);

    $scope.$on('$ionicView.enter', function () {
        viewActive = true;
        if (!roomServiceOnlineRegistered) {
            roomServiceOnlineRegistered = true;
            RoomService.onOnlineChanged(onRoomServiceOnlineChanged);
        }
    });

    $scope.$on('popover.hidden', function ($event, popover) {
        if (popover === durationControls || popover === dialingControls) {
            popover.remove();
        }
    });

    $scope.$on('popover.removed', function ($event, popover) {
        if (popover === durationControls) {
            durationControls = null;
        } else if (popover === dialingControls) {
            dialingControls = null;
            vm.selectedEntry = null;
        }
    });

    $rootScope.$on('SideBarMinimized', function (event, minimized) {
        if (!viewActive) return;
        updateDirectoryItemWidth();
    });

    $window.addEventListener('resize', onWindowResize);

    $scope.$on('$destroy', function () {
        if (hasKeyboard) {
            $window.removeEventListener('native.keyboardhide', keyboardHideHandler);
        }
        $window.removeEventListener('resize', onWindowResize);
        if (roomServiceOnlineRegistered) RoomService.offOnlineChanged(onRoomServiceOnlineChanged);
    });

    function canCallClass(callClass) {
        return CallsService.canCallClass(callClass);
    }

    function canCallType(callType) {
        if (callType === 'audio') return CallsService.canCallClass(callType);
        return CallsService.canCallType(callType);
    }

    function clearSearch() {
        vm.search = '';
        updateSearchResults();
    }

    function createGetterSetter(initValue) {
        var _value = initValue;
        return function (newValue) {
            if (arguments.length > 0) {
                _value = newValue;
            }
            return _value;
        };
    }

    function filterEntryByContactType(value) {
        return angular.isDefined(
            objectToArray(value.contacts).find(function (contact) {
                if (selectedDirectoryTab === 'zoom') {
                    return contact.type === 'zoom';
                } else {
                    return contact.type !== 'zoom';
                }
            })
        );
    }

    function filterEntryBySearch(value) {
        var combined;
        if (value.firstName && value.lastName) {
            combined = value.firstName + ' ' + value.lastName;
        }
        return (
            (value.firstName && matchOnWords(value.firstName, searchRegex)) ||
            (value.lastName && matchOnWords(value.lastName, searchRegex)) ||
            (value.firstName && value.firstName.match(searchRegex)) ||
            (value.lastName && value.lastName.match(searchRegex)) ||
            (combined && combined.match(searchRegex))
        );

        function matchOnWords(target, regex) {
            var parts = target.split(/\s+/);
            for (var i = 0; i < parts.length; i++) {
                if (parts[i].match(regex) !== null) {
                    return true;
                }
            }
            return false;
        }
    }

    function findContactByTypeOrNumber(contacts, targetContact) {
        // Search a list of contacts for a target contact with either matching:
        // 1) type
        // 2) number
        // 3) type and number
        for (var key in contacts) {
            if (!contacts.hasOwnProperty(key)) continue;
            if (targetContact.hasOwnProperty('type') && contacts[key].type !== targetContact.type) {
                continue;
            }
            if (
                targetContact.hasOwnProperty('number') &&
                contacts[key].number !== targetContact.number
            ) {
                continue;
            }
            return contacts[key];
        }
        return null;
    }

    function findEntryByContact(entries, targetContact) {
        // Search a list of directory entries for a target contact with either
        // matching:
        // 1) type
        // 2) number
        // 3) type and number
        if (entries === null) return null;
        for (var key in entries) {
            if (!entries.hasOwnProperty(key)) continue;
            if (findContactByTypeOrNumber(entries[key].contacts, targetContact) !== null) {
                return entries[key];
            }
        }
        return null;
    }

    function formatDuration(value) {
        return moment.duration(value, 'minutes').format('h __ m __', { trim: 'both' });
    }

    function getBaseFontSize() {
        var htmlEl = $document[0].querySelector('html');
        var fontSizeStr = htmlEl ? $window.getComputedStyle(htmlEl).fontSize : '';
        var fontSize = parseFloat(fontSizeStr.slice(0, fontSizeStr.length - 2));
        return isNaN(fontSize) ? defaultBaseFontSizePx : fontSize;
    }

    function getCallClass(contact) {
        if (contact.type === 'audio') return contact.type;
        return KayleeService.getCallClass(contact.type);
    }

    function getCallForInvitation() {
        var calls = CallsService.getActiveCalls();
        for (var i = 0; i < calls.length; i++) {
            if (calls[i].canInvite) {
                return calls[i];
            }
        }
        return null;
    }

    function getCallMethodFromContact(contact) {
        if (angular.isDefined(contact.$callMethod)) return contact.$callMethod;

        var numberParts = contact.number.split(/\s*,\s*/).reduce(function (acc, curr) {
            // omit empty number parts
            return curr.length === 0 ? acc : acc.concat(curr);
        }, []);
        var number = numberParts.length > 0 ? numberParts[0] : '';
        var meetingCodes = numberParts.length > 1 ? numberParts.slice(1) : undefined;
        var callMethod = {};
        if (contact.type === 'audio') {
            callMethod.callClass = contact.type;
        } else {
            callMethod.callType = contact.type;
        }
        callMethod.displayDialString = number;
        callMethod.dialString = number.replace(/[-+()\s]/g, '');
        if (angular.isDefined(meetingCodes)) {
            callMethod.meetingCodes = {};
            for (var i = 0; i < meetingCodes.length; i++) {
                callMethod.meetingCodes['a' + i] = meetingCodes[i];
            }
        }
        contact.$callMethod = callMethod;
        return callMethod;
    }

    function getContactPictureStyle(entry) {
        var entryKey = getEntryKey(entry);
        if (entryKey === null) {
            return '';
        }

        if (
            !angular.isDefined(entryStyleCache[entryKey]) ||
            entry.picture !== entryStyleCache[entryKey].picture
        ) {
            entryStyleCache[entryKey] = {
                style: ContactUtilityService.getContactPictureStyle(entry, true),
                picture: angular.copy(entry.picture),
            };
        }

        return entryStyleCache[entryKey].style;
    }

    function getEntryKey(entry) {
        if (entry.hasOwnProperty('$id')) {
            return entry.$id;
        }
        return null;
    }

    function getMeetingCodesLabel(callMethod) {
        if (callMethod === null || !callMethod.hasOwnProperty('meetingCodes')) return '';

        /// Label for meeting codes parsed from calendar event invitation
        return gettextCatalog.getString('Meeting codes: {{meetingCodes}}', {
            meetingCodes: vm.callfields.getMeetingCodes(callMethod),
        });
    }

    function getContactFilter() {
        if (selectedDirectoryTab === 'zoom') {
            return zoomContactFilter;
        } else {
            return otherContactFilter;
        }
    }

    function getFirstNameOrLastName(entry) {
        if (!entry.firstName || entry.firstName.trim().length === 0) {
            return entry.lastName;
        }
        return entry.firstName;
    }

    function getInviteeIds(invitees, inviteToCall) {
        var ids = [];
        for (var key in invitees) {
            if (!invitees.hasOwnProperty(key)) continue;
            if (!invitees[key].hasOwnProperty('contacts')) continue;
            var invitee = invitees[key];
            for (var key2 in invitee.contacts) {
                if (!invitee.contacts.hasOwnProperty(key2)) continue;
                if (invitee.contacts[key2].type !== 'zoom') continue;
                if (!invitee.contacts[key2].number || invitee.contacts[key2].number.length < 1) {
                    continue;
                }
                if (inviteToCall) {
                    ids.push({
                        address: invitee.contacts[key2].number,
                        type: invitee.contacts[key2].type,
                    });
                } else {
                    ids.push(invitee.contacts[key2].number);
                }
            }
        }
        return ids;
    }

    function getMeetNowButtonCaption() {
        /// Button label for the Meet Now / Invite button in directory
        return vm.showInvite()
            ? gettextCatalog.getString('Invite')
            : gettextCatalog.getString('Meet Now');
    }

    function getMeetNowButtonClass() {
        if (vm.showInvite()) {
            if (vm.invitees && vm.invitees.length > 0) {
                return 'onhook';
            } else {
                return 'disabled';
            }
        } else {
            if (vm.canCallClass('video')) {
                return 'onhook';
            } else {
                return 'disabled';
            }
        }
    }

    function getPresenceMessage(entry) {
        switch (entry.presence) {
            case 'online':
                if (!entry.isRoom) {
                    if (entry.onDesktop) {
                        /// User presence status string
                        return gettextCatalog.getString('Desktop');
                    } else if (entry.onMobile) {
                        /// User presence status string
                        return gettextCatalog.getString('Mobile');
                    }
                    /// User presence status string
                    return gettextCatalog.getString('Online');
                }
                /// User presence status string
                return gettextCatalog.getString('Available');
            case 'offline':
                /// User presence status string
                return gettextCatalog.getString('Offline');
            case 'busy':
                /// User presence status string
                return gettextCatalog.getString('In a meeting');
            case 'dnd':
                /// User presence status string
                return gettextCatalog.getString('Do not disturb');
            case 'away':
                /// User presence status string
                return gettextCatalog.getString('Away');
            case 'unknown':
                /// User presence status string
                return gettextCatalog.getString('Unknown');
            default:
                break;
        }
        return '';
    }

    function getRoomNameOrLastName(entry) {
        if (entry.isRoom) {
            var roomName =
                (entry.firstName ? entry.firstName : '') +
                ' ' +
                (entry.lastName ? entry.lastName : '');
            return roomName.trim();
        }
        if (!entry.lastName || entry.lastName.trim().length === 0) {
            return entry.firstName;
        }
        return entry.lastName;
    }

    function hideDialingControls() {
        if (dialingControls !== null) {
            return dialingControls.remove();
        }
        return $q.resolve();
    }

    function hideDurationControls() {
        if (durationControls !== null) {
            return durationControls.remove();
        }
        return $q.resolve();
    }

    function insertDividers(entries, addedEntry) {
        if (selectedTabSupportsInvitation()) {
            // If the addedEntry is supplied, check whether we already have
            // any dividers we need
            if (
                angular.isDefined(addedEntry) &&
                ((addedEntry.isRoom && directoryEntryDividers.rooms) ||
                    (!addedEntry.isRoom && directoryEntryDividers.people))
            ) {
                // Skip adding divider since it already exists
                return entries;
            }
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].isRoom && !directoryEntryDividers.rooms) {
                    directoryEntryDividers.rooms = {
                        isDivider: true,
                        /// Directory entries grouping label
                        label: gettextCatalog.getString('Rooms'),
                    };
                    entries.splice(i, 0, directoryEntryDividers.rooms);
                } else if (!entries[i].isRoom && !directoryEntryDividers.people) {
                    directoryEntryDividers.people = {
                        isDivider: true,
                        /// Directory entries grouping label
                        label: gettextCatalog.getString('People'),
                    };
                    entries.splice(i, 0, directoryEntryDividers.people);
                }
            }
        }
        return entries;
    }

    function inviteToCall() {
        var call = getCallForInvitation();
        if (call === null) {
            log.error('No active call');
            return;
        }
        if (vm.invitees.length === 0) return;
        CallsService.inviteToCall(call, getInviteeIds(vm.invitees, true));
        $state.go('control.calls').then(function () {
            entryChecked = {};
            vm.invitees = [];
            clearSearch();
        });
    }

    function isEntryChecked(entry) {
        // Access to the getter/setters for the checked status of an entry

        var entryKey = getEntryKey(entry);
        if (entryKey === null) {
            return function () {
                return false;
            };
        }

        if (!angular.isDefined(entryChecked[entryKey])) {
            entryChecked[entryKey] = createGetterSetter(false);
        }

        return entryChecked[entryKey];
    }

    function isNotRoom(entry) {
        return entry.isRoom !== true;
    }

    function isTabSelected(tabName) {
        return tabName === selectedDirectoryTab;
    }

    function keepSearchFocused() {
        return hasKeyboard && maintainSearchFocus;
    }

    function keyboardHideHandler(e) {
        // JS scrolling to support collection-repeat in directory list requires
        // an explicit resize after the keyboard closes to restore its proper
        // size.
        if ($state.current.name !== 'control.directory') return;
        $timeout(function () {
            if ($state.current.name !== 'control.directory') return;
            $ionicScrollDelegate.$getByHandle('directory-entries-scroll').resize();
        }, 500);
    }

    function meetNow(callClass, $event) {
        var callType = null;
        var i;

        // Get best available call type matching callClass.

        for (i = 0; i < KayleeService.callTypes.length; i++) {
            if (
                CallsService.canCallType(KayleeService.callTypes[i]) &&
                KayleeService.getCallClass(KayleeService.callTypes[i]) === callClass
            ) {
                callType = KayleeService.callTypes[i];
                break;
            }
        }

        if (callType === null) {
            vm.tooltip.show(CallsService.getExceededMaxCallsStringByClass(callClass), $event);
            return;
        }

        var callMethod = {
            callType: callType,
            durationMinutes: vm.durationInMinutes,
        };

        log.debug('meet now (' + callType + '), durationMinutes: ' + vm.durationInMinutes);

        clearDirectoryUiState = true;
        if (vm.invitees.length === 0) {
            log.debug('\tno invitees');
            CallsService.placeCallByType(callMethod);
        } else {
            for (i = 0; i < vm.invitees.length; i++) {
                log.debug('\t' + vm.invitees[i].firstName + ' ' + vm.invitees[i].lastName);
            }
            callMethod.invite = getInviteeIds(vm.invitees);
            CallsService.placeCallByType(callMethod);
        }
    }

    function onChangeSearch() {
        updateSearchResults();
    }

    function onClearSearch() {
        setKeepSearchFocused();
        clearSearch();
    }

    function onClickDirectoryTab(tabName) {
        // Need to reset tab selection since template will ng-if the list containing
        // collection-repeat. This is necessary to reset the height of items correctly
        // when tabs have different height items.
        selectedDirectoryTab = null;
        // Although updateSearchResults() will resetSearchResults(), do it
        // early here to ensure any search result updates in progress
        // won't flicker during a tab transition.
        resetSearchResults();
        $timeout(function () {
            selectedDirectoryTab = tabName;
            $timeout(function () {
                updateSearchResults();
                updateDirectoryItemWidth();
            }, 250);
        });
    }

    function onCheckEntry(entry) {
        // We want the click on the checkbox to activate the parent item, so
        // we'll just record that the checkbox changed state already, so we
        // don't change it again in the item click handler.
        alreadyCheckedEntry = entry;
    }

    function onClickEntry($event, entry) {
        // TODO: would be nice to scroll entry into view if necessary, but have
        // to use $ionicScrollDelegate to do this manually since scrolling is
        // handled by JS (i.e. can't use el.scrollIntoViewIfNeeded().)
        if (selectedTabSupportsInvitation()) {
            setKeepSearchFocused();
            if (alreadyCheckedEntry !== entry) {
                vm.isEntryChecked(entry)(!vm.isEntryChecked(entry)());
            }
            alreadyCheckedEntry = null;
            onUpdateInvitees(entry);
        } else {
            vm.selectedEntry = entry;
            onShowDialingControls($event);
        }
    }

    function onClickInvitee(entry) {
        setKeepSearchFocused();
        if (vm.selectedInvitee !== entry) {
            vm.selectedInvitee = entry;
        } else {
            vm.selectedInvitee = null;
        }
    }

    function onClickSearch($event) {
        $timeout(function () {
            if ($state.current.name !== 'control.directory') return;
            var delegate = $ionicScrollDelegate.$getByHandle('directory-entries-scroll');
            delegate.resize();

            if (!vm.selectedTabSupportsInvitation()) return;
            delegate = $ionicScrollDelegate.$getByHandle('invitees-scroll');
            delegate.resize();
            delegate.scrollBottom(true);
        }, 2000);
    }

    function onDialContact(contact, $event) {
        if (contact.type === 'audio') {
            if (!CallsService.canCallClass(contact.type)) {
                vm.tooltip.show(
                    CallsService.getExceededMaxCallsStringByClass(contact.type),
                    $event
                );
                return;
            }
        } else {
            if (!CallsService.canCallType(contact.type)) {
                vm.tooltip.show(CallsService.getExceededMaxCallsStringByType(contact.type), $event);
                return;
            }
        }

        hideDialingControls().then(function () {
            vm.selectedEntry = null;
            $ionicViewSwitcher.nextDirection('forward');
            var callMethod = getCallMethodFromContact(contact);
            if (callMethod.hasOwnProperty('callClass')) {
                CallsService.placeCallByClass(callMethod);
            } else {
                CallsService.placeCallByType(callMethod);
            }
        });
    }

    function onDirectoryChanged() {
        if (
            previousDirectoryBeforeModifiedTimestamp === null ||
            previousDirectoryBeforeModifiedTimestamp !==
                sutl.getNode(vm.directory, ['beforeModified'])
        ) {
            previousDirectoryBeforeModifiedTimestamp = sutl.getNode(vm.directory, [
                'beforeModified',
            ]);
            log.debug('onDirectoryChanged directory update started');
            unregisterDirectoryEntryHandlers();
        }
        if (
            previousDirectoryModifiedTimestamp === null ||
            previousDirectoryModifiedTimestamp !== sutl.getNode(vm.directory, ['modified'])
        ) {
            previousDirectoryModifiedTimestamp = sutl.getNode(vm.directory, ['modified']);
            log.debug('onDirectoryChanged directory update finished');
            resetDirectoryTabSelection(updateDirectoryCapabilities()).then(function (didTabChange) {
                // If the directory timestamp was modified, we always update
                // search results since it means the directory contents changed.
                // We also resetSearchResults() even though updateSearchResults()
                // will call it to keep the busy spinner up longer while waiting
                // on the timeout that handles search results update.
                resetSearchResults();
                $timeout(function () {
                    updateSearchResults();
                }, 500);
                updateInviteesProperties();
            });
        }
    }

    function onDirectoryEntryAdded(entryId, entry) {
        if (ignoreEntryAdded) return;
        log.debug('onDirectoryEntryAdded: ' + entryId);
        // Check whether the entry is included in the currently selected tab
        if (!filterEntryByContactType(entry)) return;
        // Currently, just rebuild the search results. If directory items
        // end up being added frequently, maybe this isn't performant, in
        // which case we'll have to do an insertion into the current search
        // results.
        $timeout(updateSearchResults);
    }

    function onDirectoryEntryChanged(entryId, entry) {
        log.debug('onDirectoryEntryChanged: ' + entryId);
        var foundIndex = vm.searchResults.findIndex(function (el) {
            return el.$id === entryId;
        });
        if (entry && foundIndex !== -1) {
            entry.$id = entryId;
            // Copy over updated entry's properties
            // (Don't use splice on vm.searchResults, as it will reset the
            // scroll position of the search results.)
            angular.extend(vm.searchResults[foundIndex], entry);
        }
    }

    function onDirectoryEntryRemoved(entryId) {
        log.debug('onDirectoryEntryRemoved: ' + entryId);
        // Check whether the entry is included in the currently selected tab
        if (!vm.searchResults) return;
        var foundIndex = vm.searchResults.findIndex(function (el) {
            return el.$id === entryId;
        });
        if (foundIndex !== -1) {
            vm.searchResults.splice(foundIndex, 1);
        }
    }

    function onIncrementDurationTouch($event, increment) {
        var duration = vm.durationInMinutes + increment;
        if (duration > vm.maxDuration) {
            duration = vm.maxDuration;
        } else if (duration < vm.minDuration) {
            duration = vm.minDuration;
        }
        vm.durationInMinutes = duration;
    }

    function onKayleeConnectionStateChanged(connected) {
        if (connected && !previousKayleeConnected) {
            log.debug('onKayleeConnectionStateChanged, connected, clearing entry style cache');
            $scope.$apply(function () {
                entryStyleCache = {};
            });
        }
        previousKayleeConnected = connected;
    }

    function onKeydownSearch($event) {
        if ($event.keyCode === 13) {
            document.getElementById('searchText').blur();
        } else {
            $ionicScrollDelegate.$getByHandle('directory-entries-scroll').scrollTop(true);
        }
    }

    function onMeetNow(callClass, $event) {
        setMeetNowPressedCaption();
        if (vm.showInvite()) {
            inviteToCall();
        } else {
            meetNow(callClass, $event);
        }
    }

    function onRemoveInvitee(entry) {
        setKeepSearchFocused();
        vm.isEntryChecked(entry)(false);
        onUpdateInvitees(entry);
    }

    function onResetSelections() {
        vm.selectedEntry = null;
        vm.selectedInvitee = null;
    }

    function onRoomServiceOnlineChanged(online) {
        log.debug('onRoomServiceOnlineChanged: ' + online);
        unregisterDirectoryChangeHandler();
        unregisterDirectoryEntryHandlers();
        if (online) {
            room = RoomService.getRoom();
            var directory = room.$getDirectory();
            if (directory !== vm.directory) {
                // We may get multiple online state notifications from room
                // service that don't change the directory (seems like Kaylee
                // connection state may trigger this.)
                vm.directory = directory;
                registerDirectoryChangeHandler();
            }
        } else {
            room = null;
            vm.directory = null;
            previousDirectoryBeforeModifiedTimestamp = null;
            previousDirectoryModifiedTimestamp = null;
        }
    }

    function onScroll() {
        var delegate = $ionicScrollDelegate.$getByHandle('directory-entries-scroll');
        if (delegate) {
            var scrollPos = delegate.getScrollPosition();
            if (scrollPos) {
                var newScrollTop = scrollPos.top;
                if (newScrollTop !== lastScrollTop) {
                    lastScrollTop = newScrollTop;
                    vm.selectedEntry = null;
                }
            }
        }
    }

    function onShowDialingControls($event) {
        return hideDialingControls().then(function () {
            return $ionicPopover
                .fromTemplateUrl('directoryDialContacts.html', {
                    scope: $scope,
                    positionView: SelectMenuPositionService.createPositionViewHandler(),
                })
                .then(function (popover) {
                    dialingControls = popover;
                    return dialingControls.show($event);
                });
        });
    }

    function onShowDurationControls($event) {
        return hideDurationControls().then(function () {
            return $ionicPopover
                .fromTemplateUrl('meetingDurationControl.html', {
                    scope: $scope,
                })
                .then(function (popover) {
                    durationControls = popover;
                    return durationControls.show($event).then(function () {
                        $scope.$broadcast('rzSliderForceRender');
                    });
                });
        });
    }

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        if (toState.name !== 'control.directory') {
            viewActive = false;
            vm.selectedEntry = null;
            vm.tooltip.hide();
            hideDurationControls();
            log.debug('onStateChanged updated directory');
            $timeout(function () {
                if (clearDirectoryUiState) {
                    clearDirectoryUiState = false;
                    vm.searchText = '';
                    entryChecked = {};
                    vm.invitees = [];
                }
                resetDirectoryTabSelection(true).then(function (didTabChange) {
                    if (didTabChange) {
                        if (directoryEntryHandlersRegistered) unregisterDirectoryEntryHandlers();
                        updateSearchResults();
                    }
                });
            }, 500);
        } else {
            $timeout(function () {
                if ($state.current.name !== 'control.directory') return;
                $ionicScrollDelegate.$getByHandle('directory-entries-scroll').scrollTop(false);
                if (selectedTabSupportsInvitation()) {
                    $ionicScrollDelegate.$getByHandle('invitees-scroll').scrollBottom(false);
                }
            }, 250);
        }
    }

    function onUpdateInvitees(entry) {
        var idx = vm.invitees.findIndex(function (el) {
            var key;
            var key2;
            var found = false;
            for (key in el.contacts) {
                if (!el.contacts.hasOwnProperty(key)) continue;
                for (key2 in entry.contacts) {
                    if (!entry.contacts.hasOwnProperty(key2)) continue;
                    if (
                        el.contacts[key].type === entry.contacts[key2].type &&
                        el.contacts[key].number === entry.contacts[key2].number
                    ) {
                        found = true;
                        break;
                    }
                }
                if (found) break;
            }
            return found;
        });
        var delegate = $ionicScrollDelegate.$getByHandle('invitees-scroll');
        if (vm.isEntryChecked(entry)() && idx === -1) {
            vm.invitees.push(angular.copy(entry));
            $timeout(function () {
                delegate.resize();
                delegate.scrollBottom(true);
            }, 500);
        } else if (!vm.isEntryChecked(entry)() && idx !== -1) {
            vm.invitees.splice(idx, 1);
            $timeout(function () {
                delegate.resize();
                delegate.scrollBottom(true);
            }, 500);
        }
        vm.selectedInvitee = null;
    }

    function onWindowResize() {
        updateDirectoryItemWidth();
        // updateDirectoryItem will send a resize request to ensure directory items
        // have calculated, but we need one more even more delayed after a window
        // resize
        $timeout(function () {
            if ($state.current.name !== 'control.directory') return;
            $ionicScrollDelegate.$getByHandle('directory-entries-scroll').resize();
        }, 800);
    }

    function registerDirectoryChangeHandler() {
        if (vm.directory === null) return;
        vm.directory.$onChange(onDirectoryChanged);
    }

    function registerDirectoryEntryHandlers() {
        if (vm.directory === null) return;
        vm.directory.$onEntryAdded(onDirectoryEntryAdded);
        vm.directory.$onEntryRemoved(onDirectoryEntryRemoved);
        vm.directory.$onEntryChanged(onDirectoryEntryChanged);
        directoryEntryHandlersRegistered = true;
    }

    function resetDirectoryTabSelection(forceDefault) {
        var previousSelectedTab = selectedDirectoryTab;
        if (RoomService.online() && vm.directory !== null) {
            if (forceDefault || selectedDirectoryTab === null) {
                selectedDirectoryTab = null;
                return $timeout(function () {
                    if (
                        directoryCanInvite ||
                        sutl.getNode(room, 'configuredCaps.callSupportsInvitation.zoom', false)
                    ) {
                        selectedDirectoryTab = 'zoom';
                    } else if (directoryCanDial) {
                        selectedDirectoryTab = 'phone';
                    }
                    updateDirectoryItemWidth();
                }).then(function () {
                    return $q.resolve(previousSelectedTab !== selectedDirectoryTab);
                });
            }
        }
        return $q.resolve(false);
    }

    function resetSearchResults() {
        // If search results are already being updated, cancel operation
        if (updateSearchResultsTimeout !== null) {
            $timeout.cancel(updateSearchResultsTimeout);
            updateSearchResultsTimeout = null;
        }
        if (searchResultTimeout !== null) {
            $timeout.cancel(searchResultTimeout);
            searchResultTimeout = null;
        }
        // We set the search results back to empty to ensure the rendering of item heights
        // works correctly for large directory updates.
        vm.searchResults = [];
        processingSearchResults = true;
    }

    function selectedTabSupportsInvitation() {
        return (
            selectedDirectoryTab === 'zoom' ||
            (selectedDirectoryTab === null &&
                sutl.getNode(room, 'configuredCaps.callSupportsInvitation.zoom', false))
        );
    }

    function setKeepSearchFocused() {
        if (hasKeyboard && cordova.plugins.Keyboard.isVisible) {
            maintainSearchFocus = true;
            $timeout(function () {
                maintainSearchFocus = false;
            });
        }
    }

    function setMeetNowPressedCaption() {
        meetNowPressedCaption = getMeetNowButtonCaption();
        $timeout(function () {
            meetNowPressedCaption = null;
        }, 500);
    }

    function showDirectoryTabs() {
        return supportsInvitation() && supportsDialing();
    }

    function supportsDialing() {
        return RoomService.online() && vm.directory !== null && directoryCanDial;
    }

    function supportsInvitation() {
        return (
            RoomService.online() &&
            ((vm.directory !== null && directoryCanInvite) ||
                sutl.getNode(room, 'configuredCaps.callSupportsInvitation.zoom', false))
        );
    }

    function supportsPresence(entry) {
        return entry && entry.hasOwnProperty('presence');
    }

    function unregisterDirectoryChangeHandler() {
        if (vm.directory === null) return;
        vm.directory.$offChange(onDirectoryChanged);
    }

    function unregisterDirectoryEntryHandlers() {
        if (vm.directory === null) return;
        vm.directory.$offEntryAdded(onDirectoryEntryAdded);
        vm.directory.$offEntryRemoved(onDirectoryEntryRemoved);
        vm.directory.$offEntryChanged(onDirectoryEntryChanged);
        directoryEntryHandlersRegistered = false;
    }

    function updateDirectoryCapabilities() {
        var previousDirectoryCanInvite = directoryCanInvite;
        var previousDirectoryCanDial = directoryCanDial;
        directoryCanInvite = false;
        directoryCanDial = false;

        if (vm.directory === null) return;

        // Enumerate entries to determine whether directory can dial or invite
        for (var entryId in vm.directory.entries) {
            if (!vm.directory.entries.hasOwnProperty(entryId)) continue;
            for (var contactId in vm.directory.entries[entryId].contacts) {
                if (!vm.directory.entries[entryId].contacts.hasOwnProperty(contactId)) continue;
                if (vm.directory.entries[entryId].contacts[contactId].type === 'zoom') {
                    directoryCanInvite = true;
                } else {
                    directoryCanDial = true;
                }
            }
        }

        return (
            previousDirectoryCanInvite !== directoryCanInvite ||
            previousDirectoryCanDial !== directoryCanDial
        );
    }

    function updateDirectoryItemWidth() {
        $timeout(function () {
            // Get the directory item width so we can inform collection-repeat
            // on the directory items of their actual width. Timeout allows
            // rendering to finish first.
            var item = $document[0].getElementById('directory-entries');
            directoryItemWidth = item ? $window.getComputedStyle(item).width : '';
            // this triggers a size recalculation for the collection-repeat items
            if ($state.current.name !== 'control.directory') return;
            $ionicScrollDelegate.$getByHandle('directory-entries-scroll').resize();
        }, 400);
    }

    function updateInviteesProperties() {
        // The invitees are cached in an array for more efficient binding of
        // their displayed properties (e.g. firstName, lastName, presence).
        // If the directory changes, we need to iterate the invitees and copy
        // over each matching entry's properties.
        for (var i = 0; i < vm.invitees.length; i++) {
            if (!vm.invitees[i].hasOwnProperty('contacts')) continue;
            for (var key in vm.invitees[i].contacts) {
                if (!vm.invitees[i].contacts.hasOwnProperty(key)) continue;
                var entry = findEntryByContact(
                    sutl.getNode(vm, ['directory', 'entries'], null),
                    vm.invitees[i].contacts[key]
                );
                if (entry === null) continue;
                for (var prop in entry) {
                    if (!entry.hasOwnProperty(prop)) continue;
                    vm.invitees[i][prop] = angular.copy(entry[prop]);
                }
            }
        }
    }

    function updateSearchResults() {
        var startTime = Date.now();
        var selectedEntries;

        log.debug('updateSearchResults starting');
        resetSearchResults();

        updateSearchResultsTimeout = $timeout(function () {
            updateSearchResultsTimeout = null;

            // Start by getting entries for selected directory tab
            // log.debug('selectedDirectoryTab = ' + selectedDirectoryTab);
            // log.debug('vm.directory.entries keys = ' + Object.keys(vm.directory.entries).length);
            selectedEntries =
                selectedDirectoryTab === null
                    ? []
                    : $filter('filter')(
                          objectToArray(vm.directory ? vm.directory.entries : null),
                          filterEntryByContactType
                      );

            log.debug('updateSearchResults, directory entries on tab = ' + selectedEntries.length);

            // Order results
            selectedEntries = $filter('orderBy')(selectedEntries, entryOrderByMethods);

            // Filter by the search terms
            if (vm.search.length > 0) {
                var escapedSearch = escapeRegExp(vm.search.trim());
                escapedSearch = escapedSearch.replace(/\s+/, '\\s');
                searchRegex = new RegExp('^' + escapedSearch, 'i');
                selectedEntries = $filter('filter')(selectedEntries, filterEntryBySearch);
            }

            log.debug('updateSearchResults, search results = ' + selectedEntries.length);

            // Insert any dividers
            directoryEntryDividers = {};
            selectedEntries = insertDividers(selectedEntries);

            scheduleSearchResultTimeout();
        });

        function scheduleSearchResultTimeout() {
            if (searchResultTimeout !== null) {
                $timeout.cancel(searchResultTimeout);
                searchResultTimeout = null;
            }
            searchResultTimeout = $timeout(function () {
                searchResultTimeout = null;
                var numToProcess = Math.min(searchResultProcessSize, selectedEntries.length);
                var scrollToTop = vm.searchResults.length === 0;
                for (var i = 0; i < numToProcess; i++) {
                    vm.searchResults.push(selectedEntries.shift());
                }
                if (scrollToTop) {
                    $timeout(function () {
                        if ($state.current.name !== 'control.directory') return;
                        $ionicScrollDelegate
                            .$getByHandle('directory-entries-scroll')
                            .scrollTop(true);
                    });
                }

                if (selectedEntries.length > 0) {
                    scheduleSearchResultTimeout();
                } else {
                    log.debug(
                        'Elapsed search result update time = ' +
                            (Date.now() - startTime) / 1000 +
                            ' seconds'
                    );
                    processingSearchResults = false;
                    if (!directoryEntryHandlersRegistered) {
                        ignoreEntryAdded = true;
                        registerDirectoryEntryHandlers();
                        ignoreEntryAdded = false;
                    }
                }
            });
        }

        function escapeRegExp(value) {
            return value.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
        }
    }
}

module.exports = DirectoryController;
